import {css} from '@emotion/react'

export const root = css`
    height: 100vh;
    width: 100%;
    color: white;
    background: #222;
    display: flex;
    flex-direction: row;
`;
